import React from 'react';
import { RentalStepProps, slugs, useRentalSteps } from 'rental/app/steps';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { Payment_ApplicationFragment, useInitiateRentalDirectPostMutation, useSkipPaymentMutation } from 'rental/generated.graphql';
import { PageContainer } from 'shared/components/PageContainer';
import { PageHeading } from 'shared/components/typography';
import { PaymentStep } from '../../../shared/payment/PaymentStep';


interface Props extends RentalStepProps {
  application: Payment_ApplicationFragment;
}

export const Payment = (props: Props) => {
  const portalSlug = props.application.portal.slug;
  const steps = useRentalSteps({slug: slugs.payment})
  const [skipPaymentStatus, skipPayment] = useSkipPaymentMutation();
  const [getFingerprintStatus, getFingerprint] = useInitiateRentalDirectPostMutation();

  const handleSkip = async () => {
    await skipPayment({input: {portalSlug}});
    props.onSubmitSuccessful();
  };

  return (
    <PageContainer>
      <RentalPageTitleHelmet>Payment</RentalPageTitleHelmet>
      <PageHeading>Payment</PageHeading>
      <PaymentStep
        {...props}
        prevStepLink={steps.prev?.link || null}
        nextStepLink={steps.next?.link || null}
        card={props.application.payment || null}
        skip={{
          execute: handleSkip, 
          executing: skipPaymentStatus.fetching,
        }}
        getFingerprint={{
          execute: async input => {
            const r = await getFingerprint({input: { ...input, portalSlug }}); 
            return r.data?.initiateRentalDirectPost?.nabCrn || null;
          },
          executing: getFingerprintStatus.fetching,
        }}
        hasFailed={props.application.hasDirectPostFailed}
      >
        <p>Please note: Your card will only be charged if your application is approved.</p>
      </PaymentStep>
    </PageContainer>
  )
};
